import { proxy, ref } from "valtio";
import * as THREE from "three";

import defaultCamJson from "./data/defaultCam.json";

const defaultCam = new THREE.ObjectLoader().parse(defaultCamJson);

export const storeModel = {
  appLocation: "/",
  loadingFinished: false,
  datastoreReady: false,
  languages: [],
  data: {},
  locations: ["manufacturing", "sales_offices", "sales_service"],
  contentHasMedia: false,
  contentHasPdf: false,
  sideBarVisible: false,
  sideBarToggle: false,
  currentUser: null,
  faded: false,
  autoPlay: false,
  autoPlayTimeline: null,
  autoPlayCurrentIndex: 0,
  autoPlayPath: null,
  multiuser: {
    connected: false,
    spectating: false,
    nameEntered: false,
  },
  environmentRotation: 0,
};

export const store = proxy(storeModel);

export const cameraStoreModel = {
  cameraTargetSettings: ref(defaultCam),
  enabled: true,
  rotateWithMouse: true,
  minPolarAngle: 30,
  maxPolarAngle: 80,
  zoomEnabled: true,
  translationEnabled: true,
  cameraControlsRef: ref({}),
};

export const cameraStore = proxy(cameraStoreModel);

export const authenticationModel = {};

export const authenticationStore = proxy(authenticationModel);

export default store;
